<div class="sidebar">
  <ul class="list-group">
    <li *ngFor="let item of items" class="list-group-item">
      <a [routerLink]="['/front', item.baseURL, item.url]" routerLinkActive="selected">
        {{ 'sidebar.' + item.name | translate }}
      </a>
    </li>
    <li *ngFor="let item of subItems" class="list-group-item ms-2">
      <a [routerLink]="['/front', item.baseURL, item.url]" routerLinkActive="selected">
        - {{ 'sidebar.' + item.name | translate }}
      </a>
    </li>
  </ul>
</div>
